import { render, staticRenderFns } from "./GalleriesMobile.vue?vue&type=template&id=1454afea&"
import script from "./GalleriesMobile.vue?vue&type=script&lang=js&"
export * from "./GalleriesMobile.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesMobile.vue?vue&type=style&index=0&id=1454afea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports